/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Access_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Open the Teams tab in space settings and add a team to grant everyone in it access at once. Use the Users tab to add individual people with specific permissi..." |
*
* @param {Uno_Edu_Space_Access_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_access_chip1_answer = /** @type {((inputs?: Uno_Edu_Space_Access_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Access_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen Sie den Teams-Tab in den Space-Einstellungen und fügen Sie ein Team hinzu, um allen darin auf einmal Zugriff zu gewähren. Verwenden Sie den Benutzer-Tab, um einzelne Personen mit bestimmten Berechtigungen hinzuzufügen.")
	return /** @type {LocalizedString} */ ("Open the Teams tab in space settings and add a team to grant everyone in it access at once. Use the Users tab to add individual people with specific permissions.")
});